import React, { useEffect, useState } from "react";
import FormStrip from "../../components/FormStrip";
import { useTranslation } from "react-i18next";
import { MainWrapper, PrimaryTab, PrimaryTabs, PrimaryTabsWrapper, StyledDivider } from "../../components/StyledComponent";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import { BackButton, Loader } from "@egovernments/digit-ui-react-components";
import { useHistory } from "react-router-dom";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import getCommercialData from "./getCommercialPortal";

const CommercialSelfPortal = () => {
  const dispatch = useDispatch();
  const { initFormMTDocs, resetFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const { id } = useParams();
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const { applicationData, isAppDataLoading } = getCommercialData(t, id);
  const { info: userInfo } = Digit.UserService.getUser();
  const Modal = useModal();
  const [params, setParams, clearParams] = Digit.Hooks.useSessionStorage("FORM_SELF_RESIDENTIAL", applicationData);

  useEffect(() => {
    Digit.SessionStorage.get("FILE_NO");
    Digit.SessionStorage.get("OWNER_INFO");
  }, []);

  const onSelect = (key, data, isFromCreateApi) => {
    if (isFromCreateApi) {
      setParams(data);
    } else if (key === "") {
      setParams({ ...data });
    } else {
      setParams({ ...params, ...{ [key]: { ...params[key], ...data } } });
    }
  };

  const handleTabChange = (nextTab, formData = null) => {
    if (nextTab === 1 && formData) {
      const data = { ...params, ...formData };
      Digit.OBPSService.create({ BPA: data }, tenantId)
        .then((res) => {
          if (res?.BPA?.length > 0) {
            Modal("Application Created", `Application Created Successfully!`, "success");
            history.replace(
              `/digit-ui/citizen/obps/services/mapSubmissionPortal`, ///${result?.data?.edcrDetail?.[0]?.edcrNumber}
              { data: res?.BPA?.[0] }
            );
          }
        })
        .catch((e) => {
          Modal("Error", `${e?.response?.data?.Errors[0]?.message}`, "error");
        });
    } else {
      setActiveTab(nextTab);
      Digit.SessionStorage.set("SELF_CURRENT_TAB", nextTab);
    }
  };

  useEffect(() => {
    if (id && applicationData) {
      setParams(applicationData);
      if (applicationData?.documents?.length > 0) {
        initFormMTDocs(applicationData.documents);
      }
    }
  }, [id, applicationData]);

  const renderContent = () => { 
    if (activeTab === 0) {
      return <Step1 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} id={id} />;
    } else if (activeTab === 1) {
      return <Step2 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} id={id} />;
    } else if (activeTab === 2) {
      return <Step3 formData={params} userInfo={userInfo} handleTabChange={handleTabChange} id={id} />;
    }
  };

  if (isAppDataLoading && id && !applicationData) {
    return <Loader />;
  }

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <FormStrip formName={"Self Approval Upto 30Sqm Commercial Application Form"} />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Applicant Form" />
          <PrimaryTab label="Documents" />
          <PrimaryTab label="Geo-Location" />
          <PrimaryTab label="Summary" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {renderContent()}
    </MainWrapper>
  );
};

export default CommercialSelfPortal;
